import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../lib/api';
import { qk } from '../lib/queryKeys';
import type { BootstrapResponse } from '../types/api';

// Reference data (visible projects/tasks/users for pickers + labels). Cached;
// invalidated by Manage mutations.
export function useBootstrap() {
  return useQuery({
    queryKey: qk.bootstrap,
    queryFn: () => apiGet<BootstrapResponse>('/api/bootstrap'),
    staleTime: 5 * 60 * 1000,
  });
}
